import { render, staticRenderFns } from "./FormularioPcoEmailsQueueComponent.vue?vue&type=template&id=589aeff0"
import script from "./FormularioPcoEmailsQueueComponent.vue?vue&type=script&lang=js"
export * from "./FormularioPcoEmailsQueueComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports